import {SERVICES} from '@/const/services';

const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;
const PREFIX = `${SERVICES.STATIC_URL}/s/home/`;

export const IMAGES_NAME = {
  SIGN: PREFIX + '3.0/signature.svg',
};

export const IMAGES = {
  // Banner
  BANNER_LOGIN_BG: 'c642bb352e8b2f57442722e0163053553879a6b3cace78ef21ecb66682025e11.png',
  BANNER_LOGIN_MOBILE: 'c642bb352e8b2f57442722e0163053553879a6b3cace78ef21ecb66682025e11.png',
  BANNER_LOGOUT_BG: 'e46c5c3663ca7de2fc173609f6bcf9da97fac5a513385af8470b4b2ca7ed0163.png',
  BANNER_LOGOUT_MOBILE: 'e46c5c3663ca7de2fc173609f6bcf9da97fac5a513385af8470b4b2ca7ed0163.png',
  DOWNLOAD_LOGIN: '12e183f40f5d12702dcb52e3533c9733ddbb5fd32b76685a96690835ee45ab61.png',
  DOWNLOAD_LOGOUT: '3799e947e779c60918f589fd6be647e46ce5dc1ecd7c1032bf21c0cd77632825.png',
  GIFT: '859e020c0e6c91e89afbfa229786f62e65c37097e43b0d86fc87e122ac5a7f4e.png',
  APPSTORE: '150841ad46c554d674eb89ce75479936f1072622a28a52c30926ae6d570d6841.png',
  GOOGLE: '6f494fbf8628e75a72d446ef2fba6b88fb40beefb6346b3dd09c2235e065b7fc.png',
  APK: '394e48fea16cb3e12b0e716b8032ee2c72b33f69de81fd7fd39b195216c7a6ef.png',
  QRCODE: '7e16c44a9c6f694483f48a7d26fbc9cf2757e99e65707af2988113ec2ee71b7d.png',
  // Brand
  IPHONE: '166c592c81a9f8a33a96db821c0934c98d5aebdee857e91a2b3faeb3417d07bb.png',
  BRAND_SAFE_1: '46a5679e80ef7189ed1521df332bfe0b0a7a5ad01e7089991111725b936a574f.png',
  BRAND_SAFE_2: '69f3bb7ca600eb932dac40611f665254bc434a835ebf031c865a63b039d45810.png',
  BRAND_SAFE_3: '52947c81b5741bb2a4f6832279c372c75f57b949500301984ba8aee0fdb676ed.png',
  BRAND_SUPER_1: 'e6590736c8de5378318550018d6f1ad9a165439c215c6135bd474e2d856ff235.png',
  BRAND_SUPER_2: 'ebd96ca0f3794d05183399bdabc8381e13a833a189c51b3bfe1bcde26beb0130.png',
  BRAND_SIMPLE_1: '2c3f135cdf9484e3d159de8d943e8579d0d24516cebf7cbc5f37cb963ce2c257.png',
  BRAND_SIMPLE_2: 'f821c3543d0ee1dd31d53668d0654eb08a34afa881cc1aa3fe2fb4a64e23db8e.png',
  BRAND_SIMPLE_3: 'ef03ebf89d992ae89b34c3250e74d10bd935b8bbf0ab3fd76fc47148bd377251.png',
  // Duty
  DAUPHINE_UNIVERSITY: '6c3f0fdac12afe7161182a85ad8c03d8d4493c34dc635aa41f09f0f214921f05.png',
  UNIVERSITY: '4e1e35679f44011f0562df598fe1b99d441006155cb93073280f109f64450523.png',
  // Press
  QUOTA: 'e07bd93f17cb19294c84143ed6c9d975207eaba2b04714a9bcc8fd8cc0051e6e.png',
  PRESS_FORBES: '4b951620ab0e8e0cb1e4c6a59d84bee9c250ce69af3486f952cb97e5991ac3dd.png',
  PRESS_NEW_YORK_POST: '9dd31b44d7713b8a80ac09512330b6dca44a585ef640d4611f37581ee4ebe307.png',
  PRESS_BUSINESS: 'aa9c5dd8ceca1b4fa73b8d0b1b3d6d8f65382c1f8d70f6216de3617167f2d824.png',
  PRESS_IBT: '4bfc44dae7022a233aa0340271254a42de7a02f63b1c0f7620b2f9d42a6c6066.png',
  // Knowledge
  KNOWLEDGE_BG: '35450231d3595c9422fc6f4935f6060092eaa05df857deca359f5bd36b03eab9.png',
  // Products
  PRO1: 'de9e3405e429d27d006633badb0d4c721b959b9eb99b0f9ea9b7efc82547ba09.png',
  PRO2: 'fdc66dcc900d23a1742d4bef79ee97057ce5fdfda19e86a8da72d995a7d7a71a.png',
  PRO3: '7416dd66d12d14532a92c8e1f84eca7d411587534638c5a70c52890bd019f251.png',
  // AppDownload
  DOWNLOAD_QRCODE: '79b20259279155bc68d478d435610f488a31bee451049e33e381f2c51e1be6ef.png',
  SIMULATE: 'dbfde50b15bcab6f40b1ecbedaa94bc73fad953753dcdaa0ef6b946a726df7f2.png',
  APPLE: 'aa5b679bcc85e7f6602179b7d5460529fda82ee26227c453b8becd05e3c0333a.png',
  GOOGLE_PLAY: '6191493cc76b12d03878f30bddcf9ebdd5344729ab884e84af5eb4ffaba90806.png',
  H5_GOOGLE_PLAY: '2273560ddbfe73516dab82efde8350a50804cb5576204a0bdd71dd8370c534aa.png',
  H5_APPLE: '2e1884418e87804cec7b16dd9bf7770c0b9d60e34d680f412be8548fa7aae77b.png',
  // MakeCrypto
  STEP1: '2c3f135cdf9484e3d159de8d943e8579d0d24516cebf7cbc5f37cb963ce2c257.png',
  STEP2: '269d166af46c7faa163430e94c49377e420564cae57b523e1accfef722868c31.png',
  STEP3: '1db4d9ced40157dcf44172fdba74bed016add61f01b407046144dd0acfbb8298.png',
  // Who Trust
  Forbes: '4b951620ab0e8e0cb1e4c6a59d84bee9c250ce69af3486f952cb97e5991ac3dd.png',
  IBT: '4bfc44dae7022a233aa0340271254a42de7a02f63b1c0f7620b2f9d42a6c6066.png',
  NYP: '9dd31b44d7713b8a80ac09512330b6dca44a585ef640d4611f37581ee4ebe307.png',
  MSB: '99ce3058560284752349dbcbf786d24a3a9204122099a7d727758335a0896bfc.png',
  DFI: 'b50cc6fd5dc5e53af0ff0aa9a9dad1d87763bf1b4dbda694aa0fb8283754312e.png',
  FC: '5bde7d7889f5da4dad4fe8524fc1493d7837c683ccd40f16db4fb4c8e9df0a15.png',
  PSL: '4be716806a9414307ec5fbf6c814158e27106f4385e9413c4347ab65b153a880.png',
  POLAND: 'https://img.phemex.com/v1/45939e19-0fef-4d71-bd4e-0466276230a9/05-znak-uproszczony-kolor-biale-tlo-en.png',
  CZECH: 'https://img.phemex.com/v1/ffe8eafd-3ae3-4ce0-a50f-36fb6d8e6555/2025-01-22-17-25-37.png',
  // Who Use
  USE_EN1: 'ae8a4f163e2ad43cdcf681e4daaecae8616e7b1c064bd0f2b7b171539776b526.jpg',
  USE_EN2: 'adb27546dc090da72e305d97b0cfa6c613b86b0812b1e149422fbe245f96c74a.jpg',
  USE_EN3: '7aab6f51055a52fa2f1901888ebc88c647abccaa48d970608fbd41075b8d7d78.jpg',
  USE_ES1: 'ffaa6dcb9d116a5d638aa0ed60be1c795940aafbcea3cd7aa4aac1773cfdbde3.jpg',
  USE_ES2: 'a122661c115923de8df96306f06d8185078e896b2a41da042531b2bc96806eff.jpg',
  USE_ES3: '3b1ef9c1cab330376cc60aead7c0fd9e736de6f5855a3285c891236954df1423.jpg',
  USE_TR1: 'f824e0f4b02b7f2b3a20ad255f827d8767fdd323c19953a1de7a676d24d4ce45.jpg',
  USE_TR2: 'f29faedc03d62d9e9cb31f14bc5c3a40a0049c284e927ab9fb717739e936981f.jpg',
  USE_TR3: '1f8e7d61c59fac2fa4af6f81e2e473a75705881ab20eb8e0879563994300357e.jpg',
  USE_VI1: 'a33d1b5734080db1aa43a98a4887e03211453f3545787468abca6c01b1fbe7af.jpg',
  USE_VI2: 'b1918360a540b72cc03de647ea49bf0f2796c11a8058ed5ea856e5896a2f1417.jpg',
  USE_VI3: 'af17ff5265401904b82ca54e31294f7f4c276c5356d7ce45ba381c77cc90b26c.jpg',
  // promotion
  NEWS: '4d5a0551e507464f4dbe2805b4e3b587942d6a042b2970feacd080c7fb556338.png',
  // Marquee
  MARQUEE_GOOGLE: '9e6bf6740f61eedf02f0a9ce0c292c84e8a7f5c1c530293ee40a79fed2939e50.png',
  TWITTER: '1596c41f61185da6b4b36b4807723aa81308f21e06964cc08ab5fa0cac60c528.png',
  BLOOMBERG: 'ac63d606788449f63b85ca385877c0db54c0564175dff27db9254ca415bc730f.png',
  NASDAQ: '46c5c656372f620ebee227e197226afaa994d2348323670773d32568f4132703.png',
  COIN_GECKO: '7769ea485ca64f8402566074209695e2ce9b71cae85ed7faf0210d0cd8d73400.png',
  COIN_MARKET_CAP: 'e03ec136f43bc7b7a27dd88925c51be605aab7fdcd5ac2fdf226e91f2cb3bd5b.png',
  TRADING_VIEW: '7ab9622b29eb3a23631f8a16da83eddcd0ac455ac47e2e905b8656d3366ebc49.png',
  SIMPLEX: 'f9af3e4ca94f9c4c14883233d0266e04c0b4de658be557acf76da02a96732c52.png',
  CHAINALYSIS: '884d4a0804baea0415e89478cc868a23c2ce331b4510892faa2a9e9366bbec40.png',
  JUMIO: '2a9db7037e02001fc261ee41a3483a792fd44ae2cbdcb58970ba71fb994ad46e.png',
  MOONPAY: 'ea328c0b871c6f9d721e4440b13b4624fdafde41111bbf7cfe61c75ff541a192.png',
  SOURCE: '81e282c7c90198461ab2dd58d509b4ebeadc3fdfb44918b8448d3d75498ba061.png',
  // ActionMenu
  CONTRACT: 'a7781485af8e0ffbb6b69025d8fadd9102c2b37171e4470ab0e07b0e3e80c80e.png',
  SPOT_TRADING: 'f821c3543d0ee1dd31d53668d0654eb08a34afa881cc1aa3fe2fb4a64e23db8e.png',
  BUY_CRYPTO: 'ff763f30963144efea49f64bb97a6184ce0b26da0ae5ea6aff2101b53dca7978.png',
  EARN: 'ef03ebf89d992ae89b34c3250e74d10bd935b8bbf0ab3fd76fc47148bd377251.png',
  BONUS: 'f4dfc668514c50d7aed020089021012cf535bb16bdf060dc0fc0ef8b09ee8d6f.png',
  REFERRAL: 'e5d44ea7034d48f79f69e42c2aa8c1cca6ab45ff63691f5ebaa058ff5707eb5a.png',
  MARGIN_TRADING: '0f13a181a5f87d62d620490c276f9a33638c5fb0df6aeece828028296c2c769c.png',
  SOULPASS_BG: '8fa7d19f2fe4b1c5b0bcb1358ff7d3441075d4f9bb35f0247ebf419902e1fafa.png',
  SOULPASS_BG_H5: '79d3f170f130302adf09964ce3a29731f881581cb34974df878b1c15ec9719f0.png',

  PREHEAT_BANNER: '2562652c4978c8910be1e9943db89167f37f3b5b5035729e235e399a4197e1a0.jpg',
  ARROW_RIGHT: 'ec87b8bc12fd3f7902a4e095c451d856db9ff0823c886bb3fafaedc16ebc9ead.png',
  H5_PREHEAT_BANNER: '189d436d468065f98eff67661211d5736bef3b007a4665086b9dd3f785eb3e5b.png',
  JP_BANNER_ICONS: '72ba163c0ad41f254e0c492c5d832fa11de38627670ad61dd77882afbcf265d6.png',
  PULSE: '38f0001380dfdad9eda2727e8fe35818f5eb1a7caa45087bafcc5f94e4a6e92b.png',
  DOWN_GREEN_ARROW: '8285567a1de0e57cb5e856ce7d88d8474e7f2574b1f59139c579ef375182e2d2.png',
  DOWN_GREEN_ARROW_H5: 'bc28dba9aded9b7abf3695e348b5916d6f9dc3213767b0bb08422313b7dfd09f.png',
  APP_STORE_HOME: '6513abc5b8fc4d39315a96d183b4f5bb19d96f9b714171966bfa7532e7a4636d.png',
  GOOGLE_PLAY_HOME: '9fc211f26abb9809739d08a651a03938a746e4cc29e64ab073c0ccbcb4323a25.png',
  HEART: 'e2af9bf4cceff5f5d5050dd344c8123d40bdb1347a7ec4edd6287760a18d3fd8.png',
  HAND_HEART: 'f38d64c780f942d7808946f410321a4c3822e3666013ebb0328c2c16f4adf933.png',
  TALK: '03bd26ba8ca66134ef4686a6b9d5c600166a5204ccd50dc4a9118e324f312132.png',
  ICON_POSTER_1: 'a81ae5286ee70f8cac0d0c5553f683e318ca103b8641ec57b03e458be98dcb16.png',
  ICON_POSTER_2: '3493a63d70fcf726cb1e062378eb28b3005174cda40831de0a04752d4846c0a3.png',
  ICON_POSTER_3: '5317a5be84e017e03f42640b5a843bf40095100efd0c4d41a41285b3ca8951ba.png',
  ICON_POSTER_4: 'd19c54fec938c538bc06f121bafd6c918a81f4482732e31678d837510ad91e3b.png',
  ICON_POSTER_5: '6f31a41dc56ed10a8170a455799b9821372c8f7c278eff456759bb57bacaa4cf.png',
  ICON_POSTER_5_SUB: '3b8c4445972cf991236ad2afb1070e50fb91e9b1dc86c0903e7613b6423c30b9.png',
  KOL_ICON_1: 'a244968b1d6d8a17ac126de003b6028f5cfc397768a5d04464571cca2032fb46.png',
  KOL_ICON_2: '73e87e19b5e683d2b6f7a9edfa0d11c0c5a3e842fedc9dcf64e48484ccf2ba99.png',
  KOL_ICON_3: 'e4fe3f7e55a36eb7b732d25856fc40fbc7bb7ef9a05d11061dea9bc2111c3ebc.png',
  KOL_ICON_4: '3d55ce3594314f72e222e0f3e5a2b7a1a89062bbd82197dcc1ee4935106e652a.png',
  BANNER_TEXT: '63a20da9cf7f2cce24a5d110121c72adba91eb9b55be32407cc81b468cf3ba0d.png',
};

export const IMAGE_EXTRA = {
  TWITTER: '47f07493-20b0-4316-b0b5-09b16a5d9497/twitter.svg',
  TWITTER_COLOR: 'bfd98a73-a145-4c71-9505-9b408e614dc1/twitter.svg',
  BLOOMBERG: '15d2b768-f8f3-4d8b-b25d-06e8249d0fe8/bloomberg.svg',
  BLOOMBERG_COLOR: 'dbc8cda2-51c0-4387-8766-0fb25ef05832/bloomberg.svg',
  NASDAQ: '4019d895-f02e-41a0-84a8-fb280f4a3425/nasdaq-stock-market-data-updates-reports-news-1.svg',
  NASDAQ_COLOR: '847d8293-5ffe-47aa-add9-defa77c6669f/nasdaq-stock-market-data-updates-reports-news-2.svg',
  COIN_GECKO: '9e7f6f9e-b13e-44d6-bed8-ce0cd832bd70/coingecko-1-4.svg',
  COIN_GECKO_COLOR: 'dad7a54f-b228-44b9-bc85-b0a74e64c0ca/coingecko-1-3.svg',
  COIN_MARKET_CAP: '1b0e0eef-ec40-4edb-88c7-04b4b803a8f1/coinmarketcap-seeklogo-2.svg',
  COIN_MARKET_CAP_COLOR: 'eeec0359-dab4-4e25-8b82-37e3bfe9b411/coinmarketcap-seeklogo-1.svg',
  TRADING_VIEW: '83ab9725-5707-42e6-83ce-97cc8006f958/tradingview.svg',
  TRADING_VIEW_COLOR: '1d11c24f-1d4b-40f1-b378-4c2e3dc5973c/tradingview.svg',
  SIMPLEX: 'aad23f43-85c5-4e09-9ee8-8d0b059204eb/simplex-logo-white-1.svg',
  SIMPLEX_COLOR: 'a8457783-9ed3-40be-b5f8-28eb6bc35f6a/simplex-logo.svg',
  CHAINALYSIS: 'b0b72192-b2c3-4491-b5f5-f43ff734fed5/chainalysis.svg',
  CHAINALYSIS_COLOR: 'd5b5b2ed-968e-4c90-9591-f494cdc6d7b1/chainalysis-idaup1d4-il-0-1.svg',
  JUMIO: 'c0f86825-abef-4a00-8c86-2c1901822987/jumio-black-logo.svg',
  JUMIO_COLOR: 'a54cbca1-4bf6-4762-b88a-cb7af4027cda/jumio-black-logo.svg',
  MOONPAY: 'f0bb40f2-55c0-4656-aa1e-02627798e683/moonpay.svg',
  MOONPAY_COLOR: '329a84a9-fea6-45de-94e7-eeab7fbb9b55/moonpay.svg',
  SOURCE: 'fc9cfe06-b28d-429b-8512-9424badecb66/source-forge-logo.svg',
  SOURCE_COLOR: '8c38033b-02a5-4bf6-baba-34a492d2abec/source-forge-logo.svg',
};

Object.keys(IMAGES).forEach((key) => {
  if (!IMAGES[key].startsWith('http')) {
    IMAGES[key] = [PREFIX_RECEIVE, IMAGES[key]].join('');
  }
});
